import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'craftUseStatistics',
    method: 'GET',
  });
  useEffect(() => {
    if (params) {
      let url = `/api/craft/use/statistics`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [isRequestSuccessed, data || [], isLoading, exec];
});
